import React, { useState, useLayoutEffect } from 'react';


function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
      function updateSize() {
          setSize([window.innerWidth, window.innerHeight]);
      }

      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const OverlayLoader = ({ show }) => {

  const [width, height] = useWindowSize();

  if (!show) return null;


  return (
    <div className="iframe-pre-loader">
      <div className="iframe-pre-loader-bg" style={{'width': (100 * 1.777) + 'vh', 'maxWidth': '100vw'}}> </div>
     <div className='loader-text'>
          <h3>Connecting you to the Meeting</h3>
          <p>Please wait a moment...</p>
     </div>
     <div className='loader-round'></div>
     <div className='loader-background'></div>
     <div className='loader-background-animation'></div>
    </div>
  );
};

export default OverlayLoader;